<template>
  <div class="broadcast-list row">
    <div class="col p-4">
      <div v-for="post in broadcast" :key="post.id" class="playlist">
        <strong class="broadcast-title" @click="openDetail(post)">{{ post.title }}</strong>
        <transition
          name="custom-classes-transition"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut">

          <playlist
            v-show="post.selected == true"
            :tracks="post.playlist"></playlist>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import Playlist from './Playlist'

export default {
  name: 'BroadcastList',
  components: {
    Playlist
  },
  computed: {
    ...mapState(['broadcast'])
  },
  methods: {
    ...mapActions([
      'setBroadcast',
      'setPlaylist'
    ]),
    openDetail: function (playlist) {
      let list = []
      const self = this

      // If was true, close all playlist
      if (playlist.selected) {
        playlist.selected = false
        list = this.broadcast.map(item => {
          item.selected = false
          return item
        })

        this.setBroadcast(list)
        return
      }

      // close all, open selected
      list = this.broadcast.map(item => {
        if (item.id !== playlist.id) {
          item.selected = false
          return item
        }

        self.setPlaylist(item.playlist)
        item.selected = true
        return item
      })

      this.setBroadcast(list)
    },
    selectAudio (audio) {
      if (this.currentPlay !== audio) {
        this.currentEvent = 'none'
        this.currentPlay = audio
      } else {
        this.currentEvent = this.playerAction === 'Playing'
          ? 'pause' : 'play'
      }
    }
  }
}
</script>

<style>
  .broadcast-list .broadcast-title {
    cursor: pointer;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/BroadcastList.vue